import React, { useRef } from "react";
import {
  Alert,
  Dimensions,
  Keyboard,
  Platform,
  Pressable,
  Text,
  TextInput,
  TouchableOpacity,
  TouchableWithoutFeedback,
  View,
} from "react-native";
import commonStyle from "../../assets/styles/common-style";
import { ids, styles } from "./Style";
import { theme } from "../../theme/theme";
import { useNavigation } from "@react-navigation/native";
import { LOGIN_ROUTE } from "../../navigation/NavigationConstants";
import { isTablet } from "react-native-device-info";
import { messages } from "../../resources/strings";

export const UserDetailForm = ({
  firstName,
  lastName,
  email,
  phone,
  firstNameHelpText,
  lastNameHelpText,
  emailHelpText,
  phoneHelpText,
  validateFirstName,
  validateLastName,
  validateEmail,
  validatePhone,
  isInitialSubmit,
  submitInitialForm,
}: {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  firstNameHelpText: string;
  lastNameHelpText: string;
  emailHelpText: string;
  phoneHelpText: string;
  validateFirstName: (value: string, isInitialSubmit: boolean) => void;
  validateLastName: (value: string, isInitialSubmit: boolean) => void;
  validateEmail: (value: string, isInitialSubmit: boolean) => void;
  validatePhone: (value: string, isInitialSubmit: boolean) => void;
  isInitialSubmit: boolean;
  submitInitialForm: () => void;
}) => {
  const lastNameRef = useRef<TextInput>(null);
  const phoneRef = useRef<TextInput>(null);
  const emailRef = useRef<TextInput>(null);
  const navigation = useNavigation();
  const getInputStyle = (key?: any, value?: any) =>
    key && value
      ? key == value
        ? styles.input
        : styles.inputRed
      : styles.input;

  return (
    <>
      <View
        style={[commonStyle.styles.rowFlex, styles.nameBlock]}
        dataSet={{ media: ids.nameBlock }}
      >
        <View
          style={[styles.formGroup, styles.twoColLayout]}
          dataSet={{ media: ids.twoColLayout }}
        >
          <View style={[styles.colOne]} dataSet={{ media: ids.colOne }}>
            <Text
              style={[styles.inputLabel]}
              dataSet={{ media: ids.inputLabel }}
              testID="register-page-first-name-label"
            >
              First Name
            </Text>
            <TextInput
              style={getInputStyle(firstNameHelpText)}
              onChangeText={(text) => validateFirstName(text, isInitialSubmit)}
              value={firstName}
              autoCorrect={false}
              keyboardType="default"
              returnKeyType="next"
              maxLength={40}
              onSubmitEditing={() => {
                // @ts-ignore
                lastNameRef.current?.focus();
              }}
              blurOnSubmit={false}
              testID="register-page-first-name-input"
            />
            <View
              style={[styles.errorContainer]}
              dataSet={{ media: ids.errorContainer }}
              testID="register-page-first-name-error-container"
            >
              <Text
                style={[styles.errorMessage]}
                dataSet={{ media: ids.errorMessage }}
              >
                {firstNameHelpText}
              </Text>
            </View>
          </View>
        </View>
        <View
          style={[styles.formGroup, styles.twoColLayout]}
          dataSet={{ media: ids.twoColLayout }}
        >
          <View style={[styles.colTwo]} dataSet={{ media: ids.colTwo }}>
            <Text
              style={[styles.inputLabel]}
              dataSet={{ media: ids.inputLabel }}
              testID="register-page-last-name-label"
            >
              Last Name
            </Text>
            <TextInput
              ref={lastNameRef}
              style={getInputStyle(lastNameHelpText)}
              onChangeText={(text) => validateLastName(text, isInitialSubmit)}
              value={lastName}
              maxLength={40}
              autoCorrect={false}
              //   autoComplete={isAutoCompleteOn()}
              keyboardType="default"
              returnKeyType="next"
              onSubmitEditing={() => {
                // @ts-ignore
                phoneRef.current.focus();
              }}
              blurOnSubmit={false}
              testID="register-page-last-name-input"
            />
            <View
              style={[styles.errorContainer]}
              dataSet={{ media: ids.errorContainer }}
              testID="register-page-last-name-error-container"
            >
              <Text
                style={[styles.errorMessage]}
                dataSet={{ media: ids.errorMessage }}
              >
                {lastNameHelpText}
              </Text>
            </View>
          </View>
        </View>
      </View>

      <View style={[styles.formGroup]} dataSet={{ media: ids.formGroup }}>
        <Text style={[styles.inputLabel]} dataSet={{ media: ids.inputLabel }} testID="register-page-phone-label">
          Phone Number
        </Text>
        <TextInput
          ref={phoneRef}
          style={getInputStyle(phoneHelpText)}
          onChangeText={(text) => validatePhone(text, isInitialSubmit)}
          value={phone}
          keyboardType="number-pad"
          maxLength={14}
          autoCorrect={false}
          returnKeyType="next"
          onSubmitEditing={() => {
            // @ts-ignore
            emailRef.current.focus();
          }}
          blurOnSubmit={false}
          testID="register-page-phone-input"
        />
        <View
          style={[styles.errorContainer]}
          dataSet={{ media: ids.errorContainer }}
          testID="register-page-phone-error-container"
        >
          <Text
            style={[styles.errorMessage]}
            dataSet={{ media: ids.errorMessage }}
          >
            {phoneHelpText}
          </Text>
        </View>
      </View>
      <View style={[styles.formGroup]} dataSet={{ media: ids.formGroup }}>
        <Text style={[styles.inputLabel]} dataSet={{ media: ids.inputLabel }} testID="register-page-email-label">
          Email
        </Text>
        <TextInput
          ref={emailRef}
          style={getInputStyle(emailHelpText, messages.validation.emailHint)}
          onChangeText={(text) => validateEmail(text, isInitialSubmit)}
          value={email}
          autoCorrect={false}
          //   autoComplete={isAutoCompleteOn()}
          keyboardType="email-address"
          autoCapitalize="none"
          maxLength={80}
          returnKeyType="done"
          onSubmitEditing={() => {
            submitInitialForm();
          }}
          blurOnSubmit={false}
          testID="register-page-email-input"
        />
        <View
          style={[
            styles.errorContainer,
            {
              marginTop: 5,
            },
          ]}
          dataSet={{ media: ids.errorContainer }}
          testID="register-page-email-error-container"
        >
          <Text
            style={[
              emailHelpText !== messages.validation.emailHint
                ? styles.errorMessage
                : styles.hintMessage,
            ]}
            dataSet={{
              media:
                emailHelpText !== messages.validation.emailHint
                  ? ids.errorMessage
                  : ids.hintMessage,
            }}
            testID="register-page-email-hint-label"
          >
            {emailHelpText !== messages.validation.emailAlreadyExists ? (
              emailHelpText
            ) : (
              <View
                style={{
                  flexDirection: "row",
                  justifyContent: "center",
                  flexWrap: "wrap",
                  alignItems: "center",
                }}
              >
                <Text
                  style={{
                    color:
                      emailHelpText !== messages.validation.emailHint
                        ? theme.colors.errorRed
                        : theme.colors.white,
                    width: isTablet()
                      ? "100%"
                      : Dimensions.get("screen").width * 0.8,
                  }}
                >
                  {emailHelpText}
                </Text>
              </View>
            )}
          </Text>
        </View>
      </View>

      <Pressable
        onPress={() => {
          submitInitialForm();
        }}
        style={[styles.makeaPaymentBtn]}
        dataSet={{ media: ids.makeaPaymentBtn }}
        testID="register-page-create-account-button"
      >
        <Text style={[styles.btnText]} dataSet={{ media: ids.btnText }} testID="register-page-create-account-label">
          Create Account
        </Text>
      </Pressable>
      <View
        style={[styles.loginHere, commonStyle.styles.rowFlex]}
        dataSet={{ media: ids.loginHere }}
      >
        <Text style={[styles.whiteText]} dataSet={{ media: ids.whiteText }} testID="register-page-existing-account-label">
          Already have an account?{" "}
        </Text>
        <Pressable
          onPress={() => {
            navigation.navigate(LOGIN_ROUTE as never);
          }}
        >
          <Text style={[styles.loginLink]} dataSet={{ media: ids.loginLink }} testID="register-page-login-link-label">
            Login
          </Text>
        </Pressable>
      </View>
    </>
  );
};

export default UserDetailForm;
